import { useAuth as useSharedAuth } from '@shared/v2/components/AuthContext';

const useAuth = useSharedAuth;

export default useAuth;
